// Must match ProTalent.Application.Constants.IncreasePermissions.
export const IncreasePermission = {
  Read: "Increase.Read",
  OpenPeriod: "Increase.OpenPeriod",
  ManageReportingLines: "Increase.ManageReportingLines",
  Allocate: "Increase.Allocate",
  Configure: "Increase.Configure",
  Approve: "Increase.Approve",
  ApproveFinal: "Increase.ApproveFinal",
  SubmitToSage: "Increase.SubmitToSage",
} as const;

export type IncreasePermission =
  (typeof IncreasePermission)[keyof typeof IncreasePermission];
